export * from "modules/AppointmentDetails/components/Interventions/components/GeneralInfo/components/GeneralInfoForm/hooks/useGeneralInfo";
